module.exports = __webpack_public_path__ + "static/media/icon-marker-default.666d531d.svg";